`<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
<div>
  <form @submit.prevent="loginAction" action="/" method="post">
    <vs-input
        v-if="username !== ''"
        name="username"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        disabled=""
        :label-placeholder="$t('message.login.loginField')"
        v-model="username"
        class="w-full my-6"/>

    <vs-input
      v-if="username === ''"
      name="username"
      icon-no-border
      icon="icon icon-user"
      icon-pack="feather"
      :label-placeholder="$t('message.login.loginField')"
      v-model="formUserName"
      class="w-full my-6"/>

    <vs-input
      v-if="password === ''"
      name="password"
      type="password"
      icon-no-border
      icon="icon icon-user"
      icon-pack="feather"
      :label-placeholder="$t('message.login.passwordOldField')"
      v-model="formPassword"
      class="w-full my-6"/>


    <vs-input
        type="password"
        name="passwordNew"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        :label-placeholder="$t('message.login.passwordField')"
        v-model="passwordNew"
        class="w-full my-6" />
    <vs-input
        type="password"
        name="passwordConfirmation"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        :label-placeholder="$t('message.login.passwordSecondField')"
        v-model="passwordSecond"
        class="w-full my-6" />

    <div class="h-6">
      <vs-button
        class="float-right"
        button="submit"
        v-html="$t('message.login.changeButton')"></vs-button>
    </div>
  </form>


</div>
</template>

<script>
export default{
  props: ['username', 'password'],
  data () {
    return {
      formUserName: '',
      formPassword: '',
      passwordNew: '',
      passwordSecond: ''
    }
  },
  methods: {
    loginAction () {
      this.$emit('error-change', '')
      if (this.passwordNew === this.passwordSecond) {
        this.$emit('login-action', {
          username: this.formUserName,
          password: this.formPassword,
          password_new: this.passwordNew
        })
      } else this.$emit('error-change', 'message.login.wrongPassword')
    }
  },
  mounted () {
    this.formPassword = this.password
    this.formUserName = this.username
  }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
}
</style>
